import AjaxService from "services/base/Ajax.service";

class TeamService extends AjaxService {
  async getTeams() {
    return this.get("/team/");
  }

  async upsertTeam(data) {
    return this.post("/team/upsert", data);
  }

  async deleteTeam(data) {
    return this.delete(`/team/${data}`);
  }

  async getUsersTeamsPaginated(data) {
    return this.get("/team/admin/users", data);
  }
}

export default new TeamService();
